// extracted by mini-css-extract-plugin
export default {"container":"ParkingSpotNumberPage-module__container--jc2ka"};